var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("mothers-day_default-section", {
    staticClass: "menu--section-mothers_day_cocktails",
    attrs: {
      menu: _vm.menu,
      section: _vm.section,
      "menu-version": _vm.menuVersion,
      "section-modifier": _vm.sectionModifier,
      "menu-item-component": "mothers-day-cocktail-item",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }